import { useEffect, useId } from "react";

import { useMapContentRegistry } from "./MapView.context";
import type { MapLatLng } from "./MapView.types";
import { boundsOf } from "./mapBounds";

// Declares the extent a child occupies, so the map can fit its content.
export function useMapContent(points: readonly MapLatLng[]): void {
  const id = useId();
  const registry = useMapContentRegistry();

  // The effect keys on the four edges rather than on the array, so a new
  // array holding the same coordinates does not refit the map.
  const bounds = boundsOf(points);
  const north = bounds?.north;
  const south = bounds?.south;
  const east = bounds?.east;
  const west = bounds?.west;

  useEffect(() => {
    if (
      !registry ||
      north === undefined ||
      south === undefined ||
      east === undefined ||
      west === undefined
    ) {
      return;
    }

    registry.register(id, { north, south, east, west });

    return () => registry.unregister(id);
  }, [id, registry, north, south, east, west]);
}
